var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.btnFlag)?_c('div',{staticClass:"to-top to-top-enter-done"},[_c('img',{staticClass:"img-top",attrs:{"src":require("../assets/images/top.png")},on:{"click":_vm.backTop}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }